import { Card, Input } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';
import { TRegistrationFormDataDE } from '../../../registration.types';
import styles from '../../../RegistrationForm.module.css';

type TProps = {
  disabled?: boolean;
};

export const CompanyInformationDE = ({ disabled = false }: TProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<TRegistrationFormDataDE>();

  return (
    <>
      <h2>
        <Trans>Company information</Trans>
      </h2>
      <Card className={styles.companyInfoContainer}>
        <div className={styles.formField}>
          <Input
            {...register('companyName')}
            id="companyName"
            type="text"
            label={t`Company name`}
            placeholder="Iwoca"
            disabled={disabled}
            error={errors.companyName && errors.companyName.message}
          />
        </div>
        <div className={styles.formField}>
          <Input
            {...register('vatNumber')}
            id="vatNumber"
            type="text"
            label={t`VAT number (optional)`}
            placeholder="123456"
            disabled={disabled}
          />
        </div>
        <div className={styles.formField}>
          <Input
            {...register('companyNumber')}
            id="companyNumber"
            type="text"
            label={t`Commercial register number (HR) (optional)`}
            placeholder="12345678"
            disabled={disabled}
          />
        </div>
        <div className={styles.formField}>
          <Input
            {...register('companyWebsite')}
            id="companyWebsite"
            type="text"
            label={t`Website (optional)`}
            placeholder="www.iwoca.de"
            disabled={disabled}
          />
        </div>
        <div className={styles.formField}>
          <Input
            {...register('addressLine1')}
            id="addressLine1"
            type="text"
            label={t`Street`}
            placeholder="Frankfurter Straße"
            disabled={disabled}
            error={errors.addressLine1 && errors.addressLine1.message}
          />
        </div>
        <div className={styles.formField}>
          <Input
            {...register('addressLine2')}
            id="addressLine2"
            type="text"
            label={t`House number`}
            placeholder="12"
            disabled={disabled}
            error={errors.addressLine2 && errors.addressLine2.message}
          />
        </div>
        <div className={styles.formField}>
          <Input
            {...register('postcode')}
            id="postcode"
            type="text"
            label={t`Postcode`}
            placeholder="12345"
            disabled={disabled}
            error={errors.postcode && errors.postcode.message}
          />
        </div>
        <div className={styles.formField}>
          <Input
            {...register('town')}
            id="town"
            type="text"
            label={t`City`}
            placeholder="Frankfurt"
            disabled={disabled}
            error={errors.town && errors.town.message}
          />
        </div>
      </Card>
    </>
  );
};
